<template>
  <Layout>
    <div class="row">
      <div class="col-6">
        <Maps v-if="showMaps"></Maps>
        <div v-if="showCamera">
          <canvas id="canvas" style="width: 100%; height: 100%"></canvas>
          <button @click="switchToMaps" class="btn btn-primary w-100">
            Switch to Maps
          </button>
        </div>
      </div>
      <div class="col-6">
        <div class="row no-gutters">
          <div class="col-6">
            <div class="row no-gutters">
              <div
                class="col-6 padding-0"
                v-for="(device, i) in devices"
                :key="i"
              >
                <div class="card text-center m-2" @click="showDevice(device)">
                  <p
                    :class="`${getDeviceClass(device.status)}`"
                    style="font-size: 24px"
                  >
                    <i :class="getDeviceIcon(device.name)"></i>
                  </p>
                  <span class="font-size-10 mb-2">{{
                    getDeviceName(device.name)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-7">
                <div class="flex-grow-1 align-self-center">
                  <div class="text-muted">
                    <h5 class="mb-2">
                      {{ this.currentUser.user.first_name }}
                      {{ this.currentUser.user.last_name }}
                    </h5>
                    <p class="mb-1" style="font-size: 12px">Package: PKG001</p>
                    <p class="mb-1" style="font-size: 12px">
                      Vehicle: {{ rpoVehicleNo }}
                    </p>
                    <p class="mb-1" style="font-size: 12px">Shift: Morning</p>
                    <p class="mb-1" style="font-size: 12px">
                      Last Login: {{ new Date().toLocaleString() }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="me-1">
                  <img
                    src="@/assets/images/profile.png"
                    alt
                    class="avatar-md rounded-square img-thumbnail"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="row">
          <div class="col-12">
            <b-tabs
              pills
              justified
              content-class="mt-2 text-muted"
              class="mobileView"
            >
              <!-- Accidents tab details -->
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none"> Accidents </span>
                  <span class="d-none d-sm-inline-block">Accidents</span>
                </template>
                <!-- Active Assigned Incident -->
                <div
                  v-if="
                    incidents.activeIncidents &&
                    incidents.activeIncidents.filter(
                      (accident) => accident.category_name === 'Accident'
                    ).length > 0
                  "
                >
                  <carousel :per-page="1" :mouse-drag="false">
                    <slide
                      v-for="(
                        accident, index
                      ) in incidents.activeIncidents.filter(
                        (accident) => accident.category_name === 'Accident'
                      )"
                      :key="index"
                    >
                      <div class="card glow-div p-3">
                        <p class="mb-2">Accident Id : {{ accident.id }}</p>
                        <p class="mb-2">
                          {{ $t("app.chainageNo") }} :
                          {{ accident.ch_no }}
                        </p>
                        <p class="mb-2">
                          {{ $t("app.reportedBy") }} :
                          {{ accident.reported_by_name }}
                        </p>
                        <p class="mb-2">
                          {{ $t("app.dateTime") }} :
                          {{
                            new Date(
                              accident.reported_datetime
                            ).toLocaleString()
                          }}
                        </p>
                        <div class="row">
                          <div class="col-6">
                            <router-link
                              :to="`/tablet/incident/${accident.id}`"
                            >
                              <b-button
                                size="sm"
                                variant="primary"
                                class="col-12"
                              >
                                {{ $t("app.details") }}
                              </b-button>
                            </router-link>
                          </div>
                          <div class="col-6">
                            <router-link :to="`/tablet/report/${accident.id}`">
                              <b-button
                                size="sm"
                                variant="danger"
                                class="col-12"
                              >
                                {{ $t("app.report") }}
                              </b-button>
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </slide>
                  </carousel>
                </div>
                <div class="text-center" v-else>
                  <p class="m-5">{{ $t("app.noActiveAccident") }}</p>
                </div>
              </b-tab>

              <!-- incidents tab details -->
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none"> Incidents </span>
                  <span class="d-none d-sm-inline-block">Incidents</span>
                </template>
                <!-- Active Assigned Incident -->
                <div
                  v-if="
                    incidents.activeIncidents &&
                    incidents.activeIncidents.filter(
                      (incident) => incident.category_name === 'Incident'
                    ).length > 0
                  "
                >
                  <carousel :per-page="1" :mouse-drag="false">
                    <slide
                      v-for="(
                        incident, index
                      ) in incidents.activeIncidents.filter(
                        (incident) => incident.category_name === 'Incident'
                      )"
                      :key="index"
                    >
                      <div class="card glow-incident-div p-3">
                        <p class="mb-2">Incident Id : {{ incident.id }}</p>
                        <p class="mb-2">
                          {{ $t("app.chainageNo") }} :
                          {{ incident.ch_no }}
                        </p>
                        <p class="mb-2">
                          {{ $t("app.reportedBy") }} :
                          {{ incident.reported_by_name }}
                        </p>
                        <p class="mb-2">
                          {{ $t("app.dateTime") }} :
                          {{
                            new Date(
                              incident.reported_datetime
                            ).toLocaleString()
                          }}
                        </p>
                        <div class="row">
                          <div class="col-6">
                            <router-link
                              :to="`/tablet/incident/${incident.id}`"
                            >
                              <b-button
                                size="sm"
                                variant="primary"
                                class="col-12"
                              >
                                {{ $t("app.details") }}
                              </b-button>
                            </router-link>
                          </div>
                          <div class="col-6">
                            <router-link :to="`/tablet/report/${incident.id}`">
                              <b-button
                                size="sm"
                                variant="danger"
                                class="col-12"
                              >
                                {{ $t("app.report") }}
                              </b-button>
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </slide>
                  </carousel>
                </div>
                <!-- No incident assigned yet -->
                <div class="text-center" v-else>
                  <p class="m-5">{{ $t("app.noActiveIncident") }}</p>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import { Carousel, Slide } from "vue-carousel";
import Maps from "./map.vue";
import config from "../../../constants/config";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  data() {
    return {
      rpoVehicleNo: "",
      showCamera: false,
      showMaps: true,
      selectedDevice: null,
      activeCams: [],
      activePort: null,
    };
  },
  components: {
    Layout,
    Carousel,
    Slide,
    Maps,
  },

  beforeDestroy() {
    this.stopAllRtspStreams();
  },

  computed: {
    incidents() {
      return this.$store.getters["socket/incident"];
    },
    currentUser() {
      return this.$store.getters["auth/user"];
    },
    devices() {
      return this.$store.getters["gis/devices"];
    },
  },

  watch: {
    incidents: function () {
      this.CheckTrackingTrigger();
    },
  },

  async mounted() {
    this.sockets.subscribe("CAMERA_DEVICE", (data) => {
      this.activeCams.push(data.port);
      setTimeout(() => {
        try {
          // eslint-disable-next-line no-undef
          new JSMpeg.Player(`${config.RTSP_BASE_URL}:${data.port}`, {
            canvas: document.getElementById("canvas"),
          });
        } catch (e) {
          alert(e);
        }
      }, 3000);
    });

    this.$store.dispatch("gis/setDevices", [
      { name: "front_camera_url", status: "LOADING" },
      { name: "rear_camera_url", status: "LOADING" },
      { name: "body_camera_url", status: "LOADING" },
      { name: "GPS", status: "LOADING" },
    ]);

    this.sockets.subscribe("RPO_DEVICES", (data) => {
      this.rpoVehicleNo = data.vehicle_no;
      let devices = [];
      Object.keys(data).forEach((device) => {
        if (
          device === "front_camera_url" ||
          device === "rear_camera_url" ||
          device === "body_camera_url"
        ) {
          devices.push({ name: device, url: data[device] });
        }
      });

      // eslint-disable-next-line no-undef
      ReactNativeWebView.postMessage(
        JSON.stringify({
          command: "DEVICE_STATUS",
          data: JSON.stringify(devices),
        })
      );
    });

    setInterval(() => {
      this.$socket.emit(
        "REQUEST:RPO_DEVICES",
        JSON.stringify({ userId: this.currentUser.user.id })
      );

      this.$socket.emit(
        "REQUEST:RPO_ACTIVE_ASSIGNED_INCIDENTS",
        JSON.stringify({ userId: this.currentUser.user.id })
      );
    }, 5000);

    this.CheckTrackingTrigger();
  },

  methods: {
    stopAllRtspStreams() {
      for (let cam of this.activeCams) {
        this.$socket.emit(
          "REQUEST:CAMERA_DEVICE",
          JSON.stringify({ command: "stop", id: cam })
        );
      }

      this.activeCams = [];
    },
    switchToMaps() {
      this.showCamera = false;
      this.showMaps = true;
      this.stopAllRtspStreams();
    },
    showDevice(device) {
      if (device.url) {
        this.stopAllRtspStreams();
        this.showMaps = false;
        this.showCamera = true;
        this.$socket.emit(
          "REQUEST:CAMERA_DEVICE",
          JSON.stringify({ url: device.url, command: "start" })
        );
      }
    },
    CheckTrackingTrigger() {
      if (
        this.incidents.activeIncidents &&
        this.incidents.activeIncidents.filter(
          (incident) => incident.category_name === "Accident"
        ).length > 0
      ) {
        var audio = new Audio("/accident.mp3");
        audio.play();
      }
      if (
        this.incidents.activeIncidents &&
        this.incidents.activeIncidents.filter(
          (incident) => incident.category_name === "Incident"
        ).length > 0
      ) {
        setTimeout(() => {
          var audio = new Audio("/incident.mp3");
          audio.play();
        }, 3000);
      }
    },

    getDeviceName(deviceCodeName) {
      switch (deviceCodeName) {
        case "front_camera_url":
          return "Front Camera";

        case "rear_camera_url":
          return "Rear Camera";

        case "body_camera_url":
          return "Body Camera";

        case "GPS":
          return "Location";

        default:
          return deviceCodeName;
      }
    },

    getDeviceIcon(deviceCodeName) {
      switch (deviceCodeName) {
        case "front_camera_url":
          return "mdi mdi-cctv";

        case "rear_camera_url":
          return "mdi mdi-cctv";

        case "body_camera_url":
          return "mdi mdi-camera-iris";

        case "GPS":
          return "mdi mdi-crosshairs-gps";

        default:
          return "mdi mdi-cctv";
      }
    },

    getDeviceStatus(status) {
      switch (status) {
        case true:
          return "ONLINE";

        case false:
          return "OFFLINE";

        case "LOADING":
          return "LOADING";

        default:
          return "UNKNOWN";
      }
    },

    getDeviceClass(status) {
      switch (status) {
        case true:
          return "text-success";

        case false:
          return "text-danger";

        default:
          return "text-warning";
      }
    },
  },
};
</script>
<style>
.footer-raise-btn {
  position: fixed;
  bottom: 80px;
  width: 97%;
}

.VueCarousel-dot-container {
  margin-top: -30px !important;
}

.VueCarousel-dot--active {
  margin-top: 0px !important;
}

.glow-div {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  border: none;
  color: white;
  -webkit-animation: accidentGlowing 1500ms infinite;
  -moz-animation: accidentGlowing 1500ms infinite;
  -o-animation: accidentGlowing 1500ms infinite;
  animation: accidentGlowing 1500ms infinite;
}
@-webkit-keyframes accidentGlowing {
  0% {
    background-color: #680000ea;
    -webkit-box-shadow: 0 0 3px #680000ea;
  }
  50% {
    background-color: #dd0000;
    -webkit-box-shadow: 0 0 40px #dd0000;
  }
  100% {
    background-color: #680000ea;
    -webkit-box-shadow: 0 0 3px #680000ea;
  }
}

@-moz-keyframes accidentGlowing {
  0% {
    background-color: #680000ea;
    -moz-box-shadow: 0 0 3px #680000ea;
  }
  50% {
    background-color: #dd0000;
    -moz-box-shadow: 0 0 40px #dd0000;
  }
  100% {
    background-color: #680000ea;
    -moz-box-shadow: 0 0 3px #680000ea;
  }
}

@-o-keyframes accidentGlowing {
  0% {
    background-color: #680000ea;
    box-shadow: 0 0 3px #680000ea;
  }
  50% {
    background-color: #dd0000;
    box-shadow: 0 0 40px #dd0000;
  }
  100% {
    background-color: #680000ea;
    box-shadow: 0 0 3px #680000ea;
  }
}

@keyframes accidentGlowing {
  0% {
    background-color: #b20000;
    box-shadow: 0 0 3px #b20000;
  }
  50% {
    background-color: #dd0000;
    box-shadow: 0 0 40px #dd0000;
  }
  100% {
    background-color: #b20000;
    box-shadow: 0 0 3px #b20000;
  }
}

.glow-incident-div {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  border: none;
  color: white;
  -webkit-animation: incidentGlowing 1500ms infinite;
  -moz-animation: incidentGlowing 1500ms infinite;
  -o-animation: incidentGlowing 1500ms infinite;
  animation: incidentGlowing 1500ms infinite;
}
@-webkit-keyframes incidentGlowing {
  0% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 3px #ff8800;
  }
  50% {
    background-color: #ffbb33;
    -webkit-box-shadow: 0 0 40px #ffbb33;
  }
  100% {
    background-color: #ff8800;
    -webkit-box-shadow: 0 0 3px #ff8800;
  }
}

@-moz-keyframes incidentGlowing {
  0% {
    background-color: #ff8800;
    -moz-box-shadow: 0 0 3px #ff8800;
  }
  50% {
    background-color: #ffbb33;
    -moz-box-shadow: 0 0 40px #ffbb33;
  }
  100% {
    background-color: #ff8800;
    -moz-box-shadow: 0 0 3px #ff8800;
  }
}

@-o-keyframes incidentGlowing {
  0% {
    background-color: #ff8800;
    box-shadow: 0 0 3px #ff8800;
  }
  50% {
    background-color: #ffbb33;
    box-shadow: 0 0 40px #ffbb33;
  }
  100% {
    background-color: #ff8800;
    box-shadow: 0 0 3px #ff8800;
  }
}

@keyframes incidentGlowing {
  0% {
    background-color: #f7a500;
    box-shadow: 0 0 3px #f7a500;
  }
  50% {
    background-color: #fdc046;
    box-shadow: 0 0 40px #fdc046;
  }
  100% {
    background-color: #f7a500;
    box-shadow: 0 0 3px #f7a500;
  }
}

.padding-0 {
  padding-right: 0;
  padding-left: 0;
}

p {
  margin: 0;
}
</style>
